import Cookies from 'js-cookie';

/**
 * The site-wide donation banner (footer.php).
 *
 * This component used to live inside media-player.js, which had nothing to do with it
 * and — before the player was vendored — carried a top-level import from
 * cdn.vidstack.io. A slow or unreachable CDN therefore meant `donationBanner is not
 * defined` on every page. See docs/media-flow-review.md X7.
 */
document.addEventListener('alpine:init', () => {
	Alpine.data('donationBanner', () => ({
		priceInterval: 'month',
		isCustomPrice: false,
		price: 0,
		stripePriceId: '',
		paypalPlanId: '',
		open: false,
		init: function () {
			// for testing only
			// this.open = true;
			// return;
			const closed = Cookies.get('tr.has_closed_donation');
			if (closed == '1') {
				this.open = false;
			} else {
				this.open = true;
			}
		},
		close: function () {
			Cookies.set('tr.has_closed_donation', '1', {
				path: '',
				expires: 1,
			});
			this.open = false;
		},
		navigate: function () {
			if (!this.priceInterval) {
				alert('請選擇贊助類型。');
				return;
			}

			if (!this.price) {
				alert('請選擇／輸入贊助金額。');
				return;
			}

			this.close();

			/**
			 * Every component is encoded, and the window is opened with `noopener`.
			 *
			 * `price` comes from a user-controlled `<input type="number">` via
			 * `$event.target.value`, which is a *string* and is not constrained to
			 * numerics by the input type alone — an ampersand in it used to inject an
			 * extra query parameter. `window.open(url)` with no feature string also
			 * leaves the new tab holding a live `window.opener` reference back to this
			 * document. See docs/media-flow-review.md X8.
			 */
			const params = new URLSearchParams({
				is_custom_price: this.isCustomPrice ? '1' : '0',
				price_interval: this.priceInterval,
				price: this.price,
			});

			if (!this.isCustomPrice) {
				params.set('price_id', this.stripePriceId);
				params.set('paypal_plan_id', this.paypalPlanId);
			}

			window.open(
				`/support-us?${params.toString()}`,
				'_blank',
				'noopener'
			);
		},
	}));
});
